import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  diagnosisCurrent: 0 as number,
  auditCurrent: 0 as number,
  stepLenght: 0 as number,
  externalCurrent: 0 as number,
  companyInfoCollapse: false,
};

export const utilsSlice = createSlice({
  name: "utils",
  initialState,
  reducers: {
    setNextDiagnosisCurrent: (state) => {
      state.diagnosisCurrent += 1;
    },
    setPrevDiagnosisCurrent: (state) => {
      state.diagnosisCurrent -= 1;
    },
    setStepsLenght: (state, action: PayloadAction<number>) => {
      state.stepLenght = action.payload;
    },
    setDiagnosisCurrent: (state, action: PayloadAction<number>) => {
      state.diagnosisCurrent = action.payload;
    },
    setNextAuditCurrent: (state) => {
      state.auditCurrent += 1;
    },
    setPrevAuditCurrent: (state) => {
      state.auditCurrent -= 1;
    },
    setAuditCurrent: (state, action: PayloadAction<number>) => {
      state.auditCurrent = action.payload;
    },
    setExternalCurrent: (state, action: PayloadAction<number>) => {
      state.externalCurrent = action.payload;
    },
    setNextExternalCurrent: (state) => {
      state.externalCurrent += 1;
    },
    setPrevExternalCurrent: (state) => {
      state.externalCurrent -= 1;
    },
    setCompanyInfoCollapse: (state) => {
      state.companyInfoCollapse = !state.companyInfoCollapse;
    },
  },
});

export const {
  setNextDiagnosisCurrent,
  setPrevDiagnosisCurrent,
  setStepsLenght,
  setDiagnosisCurrent,
  setNextAuditCurrent,
  setPrevAuditCurrent,
  setAuditCurrent,
  setExternalCurrent,
  setNextExternalCurrent,
  setPrevExternalCurrent,
  setCompanyInfoCollapse,
} = utilsSlice.actions;
export default utilsSlice.reducer;
